import type {
  ResourceFilterStatus,
  SearchMembershipsSearchParams,
  TeamSearchParams,
} from '@/lib/api/types/teams';

export const teamsQueryKeys = {
  all: () => ['teams'],
  teamInfo: () => ['teamInfo'],
  team: ({
    teamId,
    resourceStatus,
  }: {
    teamId?: number | null;
    resourceStatus?: ResourceFilterStatus;
  }) => ['teamInfo', teamId, resourceStatus],
  search: (params: TeamSearchParams = {}) => [
    'teams',
    'search',
    {
      query: params.query ?? '',
      sortBy: params.sortBy ?? 'NAME',
      sortDirection: params.sortDirection ?? 'ASC',
    },
    params.roleIds ?? [],
  ],
  searchTeamMembers: ({
    teamId,
    searchParams,
  }: {
    teamId?: number | null;
    searchParams: SearchMembershipsSearchParams | undefined;
  }) => ['teamInfo', teamId, searchParams],
  importTeamsSearch: ({
    sourceType,
    credentialsId,
    instanceId,
  }: {
    sourceType?: string;
    credentialsId?: number;
    instanceId?: string;
  }) => [
    'importTeamsSearch',
    {
      sourceType,
      credentialsId,
      instanceId,
    },
  ],
  lookup: ({ ids, dateRange }: { ids: number[]; dateRange: { from: string; to: string } }) => [
    'teamsLookup',
    {
      ids,
      dateRange,
    },
  ],
  syncStatus: () => ['teamsSyncStatus'],
  teamImportingCount: () => ['teamsImportingCount'],
  resourceMemberships: {
    all: () => ['resourceTeamMemberships'],
    detail: (resourceId: number) => ['resourceTeamMemberships', resourceId],
  },
};
